// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1A6Q9","footer":"ReportModalFilter_footer__3kyUC"};